var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600.000000pt",
    height: "600.000000pt",
    viewBox: "0 0 600.000000 600.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,600.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2730 5674 c-821 -98 -1527 -535 -1982 -1229 -89 -135 -218 -391 -273 -539 -186 -507 -211 -1066 -70 -1587 47 -177 94 -299 185 -484 371 -754 1080 -1305 1890 -1468 194 -39 309 -50 520 -50 211 0 326 11 520 50 1047 210 1903 1066 2113 2113 39 194 50 309 50 520 0 211 -11 326 -50 520 -140 699 -572 1328 -1188 1733 -135 88 -391 218 -539 272 -369 136 -814 192 -1176 149z m675 -332 c942 -165 1667 -831 1894 -1741 56 -224 66 -312 66 -601 0 -289 -10 -377 -66 -601 -210 -840 -858 -1488 -1698 -1698 -224 -56 -312 -66 -601 -66 -289 0 -379 10 -600 65 -841 210 -1490 859 -1700 1700 -55 221 -65 311 -65 600 0 289 10 379 65 600 210 841 859 1490 1700 1700 98 25 171 38 355 64 17 2 143 3 280 1 200 -2 274 -7 370 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2830 5010 c-237 -24 -458 -102 -645 -225 -247 -164 -386 -373 -415 -624 -18 -159 23 -292 121 -396 77 -82 157 -118 271 -123 170 -8 274 42 394 190 109 135 194 213 253 233 70 23 239 18 290 -9 51 -27 117 -101 137 -151 26 -69 16 -180 -22 -242 -54 -88 -137 -127 -374 -178 -152 -32 -215 -61 -273 -125 -75 -83 -79 -109 -75 -467 3 -299 4 -310 28 -367 33 -81 123 -176 204 -216 127 -62 280 -63 411 -1 149 69 230 192 244 370 l6 84 75 22 c225 66 447 204 558 347 128 167 189 336 212 594 53 587 -276 1065 -845 1229 -168 48 -400 72 -555 55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2810 1962 c-115 -30 -233 -118 -301 -223 -118 -184 -90 -448 65 -602 283 -283 750 -145 833 247 53 252 -115 514 -372 581 -75 19 -143 18 -225 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.6d84129ce393c4a35fd6893bab2be810.svg";
export { ForwardRef as ReactComponent };